<template>
  <div>
    <div class="xin ">
     <div class="xian-top ">
      <ul class="xian-top1 ">
        <li @click="yin30()">内容过滤</li>
        <div v-show="yin301" class="xian-cen">添加过滤规则</div>
      </ul>
      <ul class="xian-top2">
        <li @click="yin31()">Ip白名单</li>
        <div v-show="yin302" class="xian-cen">添加过滤规则</div>
      </ul>
    </div>
      <div class="xuan">
        <div class="pop-up" v-show="tanchu">
          <div class="find">
            <div class="find1">
              <div class="find-text">
                <span style="margin-right:4px"></span> 类型:
              </div>
              <div class="block">
                <el-select v-model="value" class="selece1">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="find1">
              <div class="find-text" style="padding-right:12px">
                <span style="margin:0 42px"></span> 分数:
              </div>
              <div class="block block1">
                <el-input
                  v-model="input"
                  placeholder="累计分数达到50，邮件拒收"
                ></el-input>
              </div>
            </div>
            <div class="find1">
              <div class="find-text" style="padding-right:12px">
                正则表达式过滤规则:
              </div>
              <div class="block block1">
                <el-input v-model="input"></el-input>
              </div>
            </div>
            <div class="find1">
              <div class="find-text">
                <span style="margin-right:-20px"></span> 策略类型:
              </div>
              <div class="block">
                <el-select v-model="value" class="selece1">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <el-row>
            <el-button type="primary" @click="tanSend()">保存</el-button>
            <el-button type="primary" @click="tanOff()">取消</el-button>
          </el-row>
        </div>
        <div class="gray" v-show="tanchu"></div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'

export default {
  data() {
    return {
       yin301: false,
      yin302: false,
      left: [],
      moni: [],
      input: "",
      time: new Date(2020, 9, 10, 18, 40),
      value1: "",

      tableData: [
        {
          address: "44",
        },
      ],
      emali: "",
      value: "",
      checkList: [],

      options: [
        {
          value: "选项1",
          label: "不使用TLS",
        },
        {
          value: "选项2",
          label: "增加信头标记",
        },
        {
          value: "选项3",
          label: "强制TLS",
        },
      ],
      checked: "",

      tanchu: false,

      show: false,
    };
  },
  mounted() {
      $("ul li").on("click",function(){
			
			//获取索引值 
			var index=$(this).index()
			console.log(index)
			console.log(1111)
			
			$(".tabCla div").eq(index).show().siblings().hide()
			
			
		})
    this.getLeft();
  },
  beforeRouteUpdate(to, from, next) {
    this.getLeft();

    next();
  },
  methods: {
       yin30() {
      this.yin301 = !this.yin301;
      
    },
      yin31() {
  
      this.yin302 = !this.yin302;
    },
    // 显示
    tan: function() {
      this.tanchu = true;
    },
    // 打开关闭
    tanSend: function() {
      this.tanchu = false;
    },
    tanOff: function() {
      this.tanchu = false;
    },
    // 数据
    getLeft() {
      // let sid = JSON.parse(sessionStorage.getItem("usermsg", sid)).sid;

      // 模拟数据
      this.$axios.get("/json/left.json").then((res) => {
        console.log(res);
        // console.log(55555);
        this.moni = res.data.data;
      });
      // console.log(this.ret);
      // console.log(username);
    },
  },
};
</script>
<style lang="less" scoped>

.active {
  color: #409eff !important;
}
.xian-top {
  position: relative;
  height: 34px;
  overflow: hidden;
  background: #424f63;
}
.xian-top1 {
  
  height: 60px;
  position: absolute;
  z-index: 3;
  li {
    width: 126px;
    color: #fff;
    font-size: 12px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  div {
    width: 113px;
    font-size: 12px;
    background: #fff;
    height: 60px;
    line-height: 60px;
    border: 1px solid #ccc;
    box-sizing: border-box;
  }
}
.xian-top2 {
  position: absolute;
  left: 112px;
  z-index: 3;
  li {
    width: 102px;
    color: #fff;
    font-size: 12px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  div {
    width: 102px;
    font-size: 12px;
    background: #fff;
    height: 60px;
    line-height: 60px;
    border: 1px solid #ccc;
    box-sizing: border-box;
  }
}

.tab ul{
    display: flex;
}
.xin {
   width: 98%;
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 10px 10px;
  border: 1px solid #dcdfe6;
  height: 100%;
  overflow: hidden;
}
.left2 {
  display: flex;
  box-sizing: border-box;
}
.xin /deep/.el-menu-item {
  height: 30px;
  line-height: 30px;
  box-sizing: border-box;
}
.xin /deep/.el-submenu__title {
  height: 30px;
  line-height: 30px;
  // border-left: 1px solid #fff;
  box-sizing: border-box;
}

.el-menu.el-menu--horizontal {
  border-bottom: none;
  border-right: 1px solid #fff;
}
.el-menu.el-menu--horizontal:nth-last-child(1) {
  border-right: none;
}
.xuan {
  background: #eee;
}

// 弹框
// 弹出框1
// 一行
.find {
  display: flex;
  flex-direction: column;
  text-align: left;
  background: #f1f1f1;
  border: 1px solid #dcdfe6;
  margin-top: 10px;
  padding: 40px 0;
  width: 80%;
  p {
    color: #999;
    font-size: 12px;
    text-align: center;
  }
}
.find1 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2px 0;
}
// 文字
.find-text {
  padding: 0 20px;
  font-size: 12px;
}

.el-input {
  // width: 20%;
  padding: 5px 10px 5px 0;
}

/deep/ .el-select {
  // padding-left: 30px;
  width: 222px;
}
// button  按钮
/deep/ .el-button {
  padding: 6px 10px;
  margin-left: 10px;
  margin: 5px 20px;
  font-size: 12px;
}

.pop-up {
  position: fixed;
  padding: 20px 0;
  width: 50%;
  top: 10%;
  left: 25%;
  z-index: 101;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  //   margin-left: -12.5%;
  //   margin-top: -14%;
}

.gray {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: black;
  opacity: 0.6;
  z-index: 100;
}
</style>
